import { StyleSheet } from "@react-pdf/renderer";
import { useTheme } from "@mui/material";
import { PDFStyleConfigs } from "@pages/platform-analysis-v2/_id/steps/summary/components/export-pdf/configs";

export const useAnalysisPDFStyles = () => {
  const { palette } = useTheme();

  const typographyStyle = StyleSheet.create({
    h1: {
      fontFamily: "ClashDisplay",
      fontWeight: "bold",
      fontSize: "35px",
    },
    h2: {
      fontFamily: "ClashDisplay",
      fontWeight: "bold",
      fontSize: "24px",
    },
    title: {
      fontFamily: "Epilogue",
      fontWeight: "bold",
      fontSize: "14px",
    },
    subtitle: {
      fontFamily: "Epilogue",
      fontWeight: "bold",
      fontSize: "12px",
    },
    body1: {
      fontFamily: "Epilogue",
      fontWeight: "normal",
      fontSize: "10px",
    },
    body2: {
      fontFamily: "Epilogue",
      fontWeight: "normal",
      fontSize: "8px",
    },
  });

  const pageStyle = StyleSheet.create({
    container: {
      position: "relative",
      backgroundColor: palette.common.white,
    },
    layout: {
      gap: PDFStyleConfigs.GapLarge,
      alignItems: "stretch",
      flexDirection: "column",
      justifyContent: "space-between",
      marginVertical: PDFStyleConfigs.MarginVertical,
      marginHorizontal: PDFStyleConfigs.MarginHorizontal,
    },
    header: {
      gap: PDFStyleConfigs.GapXLarge,
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      height: PDFStyleConfigs.PageHeaderHeight,
      // backgroundColor: "#4073ff", //Just turn on for testing
    },
    body: {
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      height: PDFStyleConfigs.PageBodyHeight,
      // backgroundColor: "#C5DDFD", //Just turn on for testing
    },
    footer: {
      alignItems: "center",
      alignContent: "center",
      flexDirection: "column",
      height: PDFStyleConfigs.PageFooterHeight,
      // backgroundColor: "#4073ff", //Just turn on for testing
    },
  });

  return {
    typographyStyle,
    pageStyle,
  };
};
